import { userRisk, getRules } from "../../apiCalls.js";

export const fetchUserRiskData = async (selectedUser) => {
  try {
    const riskData = await userRisk(selectedUser);
    const sortedRiskData = riskData.sort(
      (a, b) =>
        new Date(b.StratificationModel.created_at) -
        new Date(a.StratificationModel.created_at)
    );
    return sortedRiskData[0]?.StratificationModel ?? null;

    // console.log("SORTED RISK DATA:", sortedRiskData[0]?.StratificationModel);
  } catch (error) {
    console.error("Error fetching user data:", error);
  }
};

export const getGaugeValue = (riskData = []) => {
  const recentRiskLevel = riskData?.final_risk_level ?? 0;
  return recentRiskLevel / 5;
};

export const getRuleData = async (riskData) => {
  const idMostRecentRule = riskData?.id;
  if (!idMostRecentRule) return null;

  try {
    const storedRuleData = await getRules(idMostRecentRule);
    if (storedRuleData?.rule_factor) {
      storedRuleData.rule_factor = JSON.parse(storedRuleData.rule_factor);
    }
    return storedRuleData;
  } catch (error) {
    console.error("Error fetching rules:", error);
    return null;
  }
};


export const getRiskDescription = (riskData) => {
  let recentRiskLevel = getGaugeValue(riskData) * 5;
  if (recentRiskLevel === 1) return "LOW";
  if (recentRiskLevel === 2 || recentRiskLevel === 3) return "MEDIUM";
  if (recentRiskLevel === 4) return "HIGH";
  if (recentRiskLevel === 5) return "VERY HIGH";

  return "UNKNOWN";
};

export const getRiskColor = (riskData) => {
  let recentRiskLevel = getGaugeValue(riskData) * 5;

  if (recentRiskLevel === 1) return "#006600";
  if (recentRiskLevel === 2 || recentRiskLevel === 3) return "#FFDD00";
  if (recentRiskLevel === 4) return "#ffa771";
  if (recentRiskLevel === 5) return "#FF5F6D";
  return "#000000";
};
